import { Box, BlockStack, InlineStack, Spinner, Text } from '@/lib/polaris';

/** Skeleton mínimo para transiciones de contenido (sin flash de spinner). */
function ContentSkeleton() {
  return (
    <Box padding="400" minHeight="40vh">
      <BlockStack gap="400">
        <Box background="bg-fill-secondary" borderRadius="200" minHeight="2rem" />
        <Box background="bg-fill-secondary" borderRadius="200" minHeight="12rem" />
        <Box background="bg-fill-secondary" borderRadius="200" minHeight="8rem" />
      </BlockStack>
    </Box>
  );
}

export function PageLoader({
  label = 'Cargando...',
  variant = 'full',
}: {
  label?: string;
  /** 'full' = spinner centrado (pantallas de login, etc.); 'content' = skeleton en área de contenido (navegación) */
  variant?: 'full' | 'content';
}) {
  if (variant === 'content') {
    return <ContentSkeleton />;
  }
  return (
    <Box padding="800" minHeight="70vh">
      <InlineStack align="center" blockAlign="center">
        <BlockStack gap="300" inlineAlign="center">
          <Spinner accessibilityLabel={label} size="large" />
          <Text as="p" tone="subdued">
            {label}
          </Text>
        </BlockStack>
      </InlineStack>
    </Box>
  );
}
